import type { ReactNode } from 'react';
import React from 'react';

import { CloseButton } from '../../../elements/IconButtons/CloseButton';
import * as styles from '../styles/Header.styles';

type Layout = 'default' | 'stacked';

export interface HeaderProps {
  children: ReactNode;
  layout?: Layout;
  notificationStatus?: 'success' | 'normal';
  onCloseButtonClick: VoidFunction;
}

export const Header = ({
  children,
  layout = 'default',
  notificationStatus = 'normal',
  onCloseButtonClick,
}: HeaderProps) => (
  <div css={[styles.headerWrapper, styles[layout]]} data-success={notificationStatus === 'success'}>
    {children}
    <CloseButton aria-label="Close dialog" onClick={onCloseButtonClick} size="large" />
  </div>
);
